"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DismissPopupResponse () {
        return DismissPopupResponse;
    },
    get PopupDismissalResponse () {
        return PopupDismissalResponse;
    },
    get PopupKey () {
        return PopupKey;
    },
    get PopupKeyParams () {
        return PopupKeyParams;
    }
});
const _zod = require("zod");
const PopupKey = _zod.z.enum([
    "goal-coach",
    "form-building-coach",
    "competency-coach",
    "form-authoring-coach"
]);
const PopupKeyParams = _zod.z.object({
    popupKey: PopupKey
});
const PopupDismissalResponse = _zod.z.object({
    dismissed: _zod.z.boolean()
});
const DismissPopupResponse = _zod.z.object({
    success: _zod.z.boolean()
});
